module.exports = __webpack_public_path__ + "img/9788950964849.8fe78b59.jpg";